export default "__VITE_ASSET__CaNqZc8S__"